// Chrome 150+ scroll methods return a Promise instead of undefined.
// @techzyapp/ui-lib's useScrollToTop returns window.scrollTo(0, 0) directly
// from a useEffect, so React treats that Promise as a cleanup function and
// crashes with "destroy is not a function" on every route change.
// Wrapping the scroll methods to discard the return value restores the
// pre-Chrome-150 behavior. Must be imported before the app renders.
function makeVoid(target: any, method: string) {
  const original = target[method];
  if (typeof original !== "function") return;
  target[method] = function (this: any, ...args: any[]) {
    original.apply(this, args);
  };
}

makeVoid(window, "scrollTo");
makeVoid(window, "scrollBy");
makeVoid(window, "scroll");
makeVoid(Element.prototype, "scrollTo");
makeVoid(Element.prototype, "scrollBy");
makeVoid(Element.prototype, "scroll");
makeVoid(Element.prototype, "scrollIntoView");

export {};
